module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kz3M9"))).then(() => module.bundle.root('ewmtE'));